export default __webpack_public_path__ + "static/media/img--interiors-1.c8e1a72c.jpg";